import { put, takeLatest, call } from 'redux-saga/effects'
import fetchFromAPI, { getDefaultAutorizedHeaders } from 'helpers/fetchFromApi'
import * as ApiRoute from 'constants/apiRouting'
import { SHOW_NOTICE } from 'reducers/notice'
import NoticeHelper from 'helpers/notice'
import FuncHelper from 'helpers/functions'
import UrlHelper from 'helpers/url'
import { UPLOAD_FILES, REMOVE_FILES } from './reducer'

function* uploadFiles({
  payload: { file, showFileLoader, partUrl, formatMessage },
  promise,
}) {
  try {
    if (typeof showFileLoader !== 'function') {
      // eslint-disable-next-line no-param-reassign
      showFileLoader = FuncHelper.emptyFunc
    }

    showFileLoader(true)

    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders({
        'Content-Type': 'multipart/form-data',
      }),
      method: 'POST',
      partUrl: partUrl || ApiRoute.UPLOAD_FILES,
      data: file,
    })

    const { error, errors } = response
    // eslint-disable-next-line no-nested-ternary
    const notice = error
      ? errors && errors.file
        ? NoticeHelper.createErrorObj(errors.file)
        : NoticeHelper.createErrorObj(
            formatMessage({ id: 'file_upload_failure' }),
          )
      : NoticeHelper.createSuccessObj(
          formatMessage({ id: 'file_uploaded_succesfully' }),
        )

    yield put({ type: SHOW_NOTICE, notice })
    yield call(promise.resolve, response)

    showFileLoader(false)
  } catch (error) {
    console.log('FILES UPLOAD ERROR ', error)
  }
}

function* removeFiles({ payload: { id, showFileLoader }, promise }) {
  try {
    if (typeof showFileLoader !== 'function') {
      // eslint-disable-next-line no-param-reassign
      showFileLoader = FuncHelper.emptyFunc
    }

    showFileLoader(true)

    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      method: 'DELETE',
      partUrl: UrlHelper.create(ApiRoute.REMOVE_FILES, { id }),
    })

    const notice =
      response !== 204
        ? NoticeHelper.createErrorObj('File delete failure!')
        : NoticeHelper.createSuccessObj('File delete successful!')

    yield put({ type: SHOW_NOTICE, notice })
    yield call(promise.resolve, response)

    showFileLoader(false)
  } catch (error) {
    console.log('FILES REMOVE ERROR ', error)
  }
}

function* files() {
  yield takeLatest(UPLOAD_FILES, uploadFiles)
  yield takeLatest(REMOVE_FILES, removeFiles)
}

export default files
